export const SET_ALL_EMAILS_SELECTED_CAMPAIGNS = 'SET_ALL_EMAILS_SELECTED_CAMPAIGNS';
export const SET_ALL_EMAILS_SELECTED_STAGE = 'SET_ALL_EMAILS_SELECTED_STAGE';
export const SET_ALL_EMAILS_SELECTED_TAG = 'SET_ALL_EMAILS_SELECTED_TAG';
export const SET_ALL_EMAILS_SELECTED_READ_STATUS = 'SET_ALL_EMAILS_SELECTED_READ_STATUS';
export const SET_DATE_RANGE = 'SET_DATE_RANGE';
export const SET_SELECTED_INBOX = 'SET_SELECTED_INBOX';
export const SET_ALL_SNIPPETS = 'SET_ALL_SNIPPETS';
export const SET_UNREAD_EMAILS_COUNT = 'SET_UNREAD_EMAILS_COUNT';
